var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutomaticpaymentsicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Automatic_payments_icon",
    "data-name": "Automatic payments icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 162.373,
    height: 143.538,
    viewBox: "0 0 162.373 143.538",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31906",
    "data-name": "Rectangle 31906",
    width: 162.373,
    height: 143.538,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14155",
    "data-name": "Group 14155",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40627",
    "data-name": "Path 40627",
    d: "M30.962,24H25.038A1.038,1.038,0,0,1,24,22.962V1.038A1.038,1.038,0,0,1,25.038,0h5.924A1.038,1.038,0,0,1,32,1.038V22.962A1.038,1.038,0,0,1,30.962,24",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40628",
    "data-name": "Path 40628",
    d: "M104.962,24H99.038A1.038,1.038,0,0,1,98,22.962V1.038A1.038,1.038,0,0,1,99.038,0h5.924A1.038,1.038,0,0,1,106,1.038V22.962A1.038,1.038,0,0,1,104.962,24",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40629",
    "data-name": "Path 40629",
    d: "M60.108,59H42.893A.893.893,0,0,1,42,58.108V44.892A.893.893,0,0,1,42.893,44H60.108a.892.892,0,0,1,.892.892V58.108a.892.892,0,0,1-.892.892",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40641",
    "data-name": "Path 40641",
    d: "M60.108,59H42.893A.893.893,0,0,1,42,58.108V44.892A.893.893,0,0,1,42.893,44H60.108a.892.892,0,0,1,.892.892V58.108a.892.892,0,0,1-.892.892",
    transform: "translate(-27)",
    fill: "#56aa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40630",
    "data-name": "Path 40630",
    d: "M86.108,59H68.893A.893.893,0,0,1,68,58.108V44.892A.893.893,0,0,1,68.893,44H86.108a.892.892,0,0,1,.892.892V58.108a.892.892,0,0,1-.892.892",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40631",
    "data-name": "Path 40631",
    d: "M113.108,59H95.893A.893.893,0,0,1,95,58.108V44.892A.893.893,0,0,1,95.893,44h17.215a.892.892,0,0,1,.892.892V58.108a.892.892,0,0,1-.892.892",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40632",
    "data-name": "Path 40632",
    d: "M60.108,82H42.893A.893.893,0,0,1,42,81.108V67.892A.893.893,0,0,1,42.893,67H60.108a.892.892,0,0,1,.892.892V81.108a.892.892,0,0,1-.892.892",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40633",
    "data-name": "Path 40633",
    d: "M33.108,82H15.893A.893.893,0,0,1,15,81.108V67.892A.893.893,0,0,1,15.893,67H33.108a.892.892,0,0,1,.892.892V81.108a.892.892,0,0,1-.892.892",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40634",
    "data-name": "Path 40634",
    d: "M33.108,104H15.893a.893.893,0,0,1-.893-.892V89.892A.893.893,0,0,1,15.893,89H33.108a.892.892,0,0,1,.892.892v13.216a.892.892,0,0,1-.892.892",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40635",
    "data-name": "Path 40635",
    d: "M60.108,104H42.893a.893.893,0,0,1-.893-.892V89.892A.893.893,0,0,1,42.893,89H60.108a.892.892,0,0,1,.892.892v13.216a.892.892,0,0,1-.892.892",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40636",
    "data-name": "Path 40636",
    d: "M124.874,68.538a37.5,37.5,0,1,0,37.5,37.5,37.5,37.5,0,0,0-37.5-37.5m-14.485,55.7a2.05,2.05,0,0,1-2.9-.138l0,0a27.285,27.285,0,0,1-1.863-2.292,2.051,2.051,0,1,1,3.319-2.409,23.063,23.063,0,0,0,1.586,1.944,2.05,2.05,0,0,1-.138,2.9l0,0m8.09,5.056a2.049,2.049,0,0,1-2.735.961h0a26.871,26.871,0,0,1-2.593-1.428,2.049,2.049,0,1,1,2.172-3.476,22.781,22.781,0,0,0,2.2,1.208,2.052,2.052,0,0,1,.961,2.738m7.356,3.542a.934.934,0,0,1-.13-.005c-.724-.045-1.454-.118-2.18-.225-.257-.037-.515-.077-.772-.124a2.049,2.049,0,0,1,.7-4.038h.026c.206.037.414.071.627.1q.93.135,1.849.192a2.051,2.051,0,0,1-.125,4.1m7.357-.589a2.05,2.05,0,0,1-.888-4,22.735,22.735,0,1,0-27.56-24.45h3.325a1.538,1.538,0,0,1,1.263,2.414l-5.489,7.913a1.536,1.536,0,0,1-2.528,0l-5.487-7.914a1.537,1.537,0,0,1,1.263-2.413h3.554a26.823,26.823,0,1,1,32.551,28.449m-18.966-28.564c1.5-.805,2.366-1.807,2.366-3.122a6.417,6.417,0,0,0-.066-1.018h-2.186V98.115h1.939a10.657,10.657,0,0,1-.148-1.775c0-2.365,1.709-3.928,4.255-3.928a5.432,5.432,0,0,1,2.5.51l-.411,1.56a4.247,4.247,0,0,0-2.038-.427,2.207,2.207,0,0,0-2.365,2.481,7.678,7.678,0,0,0,.179,1.577h3.2v1.428h-3.04c.017.213.034.444.034.655a3.352,3.352,0,0,1-1.413,2.957v.034h6.428V104.8h-9.237Zm13.4,14.964v1.484H126v-1.481a3.224,3.224,0,0,1-3.082-3.164h1.931a.459.459,0,0,0,0,.074,1.866,1.866,0,0,0,1.989,1.735h0c1.225,0,1.726-.591,1.726-1.5,0-.977-.443-1.462-2.157-2.066-2.255-.81-3.208-1.616-3.208-3.273a2.887,2.887,0,0,1,2.792-2.952v-1.185h1.634v1.22a2.9,2.9,0,0,1,2.675,2.923h-1.923a1.346,1.346,0,0,0-.005-.19,1.563,1.563,0,0,0-1.7-1.416,1.384,1.384,0,0,0-.193-.007,1.324,1.324,0,0,0-1.278,1.369c0,.839.383,1.225,2.12,1.833,2.325.806,3.246,1.79,3.246,3.435a2.977,2.977,0,0,1-2.943,3.161m6.478-13.364c-2.458,0-3.828-1.614-4.163-4.821h-1.211V99.255h1.135c0-.157-.006-.317-.006-.48,0-.2,0-.4.013-.6h-1.142V96.956h1.249c.444-3.106,2.072-4.541,4.252-4.541a3.307,3.307,0,0,1,3.674,3.142H135.8c-.192-.933-.617-1.422-1.625-1.422s-1.776.657-2.034,2.821h3.205V98.18H132.06c-.008.183-.008.374-.008.574,0,.172,0,.34.006.5h3.292v1.209h-3.214c.224,2.095.913,3.095,2.1,3.095.965,0,1.411-.453,1.693-1.441H138a3.544,3.544,0,0,1-3.893,3.162",
    fill: "#56aa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40637",
    "data-name": "Path 40637",
    d: "M79.4,112H7V36H122V60.108c.993-.064,1.991-.108,3-.108a46.646,46.646,0,0,1,5,.275V18.759A6.76,6.76,0,0,0,123.24,12H110V27.4a1.6,1.6,0,0,1-1.6,1.6H95.6A1.6,1.6,0,0,1,94,27.4V12H36V27.4A1.6,1.6,0,0,1,34.4,29H21.6A1.6,1.6,0,0,1,20,27.4V12H6.759A6.759,6.759,0,0,0,0,18.759V113.24A6.759,6.759,0,0,0,6.759,120H81.176a45.777,45.777,0,0,1-1.774-8",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40638",
    "data-name": "Path 40638",
    d: "M87,77.381V67.892A.892.892,0,0,0,86.108,67H68.892a.892.892,0,0,0-.892.892V81.107a.893.893,0,0,0,.892.893H83.754A45.978,45.978,0,0,1,87,77.381",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40639",
    "data-name": "Path 40639",
    d: "M98.616,67H95.892a.892.892,0,0,0-.892.892v1.622Q96.745,68.173,98.616,67",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40640",
    "data-name": "Path 40640",
    d: "M80.258,89H68.892a.893.893,0,0,0-.892.892v13.216a.893.893,0,0,0,.892.892h8.159a45.782,45.782,0,0,1,3.207-15",
    fill: "#3c3c3b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomaticpaymentsicon);
export default __webpack_public_path__ + "static/media/Automatic payments icon.8691f0fd9d12604cb0b9e6a18f37ad1b.svg";
export { ForwardRef as ReactComponent };